import { render, staticRenderFns } from "./BixUserAvatar.vue?vue&type=template&id=3baee6d4&scoped=true&"
import script from "./BixUserAvatar.vue?vue&type=script&lang=ts&"
export * from "./BixUserAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./BixUserAvatar.vue?vue&type=style&index=0&id=3baee6d4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baee6d4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixImg: require('/root/project/frontend/src/components/images/BixImg.vue').default})
